import { CircularProgress, Container, Typography } from '@mui/material';

export function Loader({ loadingMessage }) {
  return (
    <Container sx={{ mt: 10, textAlign: 'center' }}>
      <CircularProgress />
      <Typography variant="body2" sx={{ mt: 2 }}>
        {loadingMessage}
      </Typography>
    </Container>
  );
}